import { getAxiosClient } from "../../axios-client";
import { ForgottenPasswordRequestBody, ForgottenPasswordResponse } from "./types";
const axiosClient = getAxiosClient();

export const forgottenPasswordSendMail = async (body: ForgottenPasswordRequestBody) => {
    return await axiosClient.ax.post<ForgottenPasswordResponse>("/Account/ForgottenPasswordSendMail", body);
};
